import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'clsx';
import { twMerge } from 'tailwind-merge';
import { getButtonClasses } from './ButtonClasses';
export const ButtonBase = React.forwardRef((t0, ref) => {
  const $ = _c(15);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== ref || $[1] !== t0) {
    const {
      color,
      disabled: t6,
      fullWidth: t7,
      shape: t8,
      size,
      type: t9,
      variant,
      ...t10
    } = t0;
    props = t10;
    const disabled = t6 === undefined ? false : t6;
    const fullWidth = t7 === undefined ? false : t7;
    const shape = t8 === undefined ? "standard" : t8;
    const type = t9 === undefined ? "button" : t9;
    const {
      buttonClasses
    } = getButtonClasses({
      color,
      disabled,
      fullWidth,
      shape,
      size,
      variant
    });
    t1 = props;
    t2 = type;
    t3 = ref;
    t4 = disabled;
    t5 = twMerge(classNames(buttonClasses, props.className));
    $[0] = ref;
    $[1] = t0;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.children || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <button {...t1} type={t2} ref={t3} disabled={t4} className={t5}>{props.children}</button>;
    $[8] = props.children;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
});
ButtonBase.displayName = 'ButtonBase';